import React from "react";
import { Icon } from "@iconify/react";
import "./style.css";
const SkillsBox = () => {
  const Skills = {
    WebSkills: [
      {
        name: "Html/Css/Scss/Flexbox",
        url: "https://camo.githubusercontent.com/9c1cb877fc965c3eebefdf54546fc6dcc5210d241c8011f02b009c66f16cd623/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f68746d6c352d253337373641422e7376673f7374796c653d666f722d7468652d6261646765266c6f676f3d68746d6c35266c6f676f436f6c6f723d776869746526636f6c6f723d453334463236",
      },
      {
        name: "JavaScript",
        url: "https://camo.githubusercontent.com/206b4e2ba8f3c9e8bb8f5d1cc7f89e363abcb3582c521a156ca05e14d7ec07b9/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f637373332d253135373242362e7376673f7374796c653d666f722d7468652d6261646765266c6f676f3d63737333266c6f676f436f6c6f723d776869746526636f6c6f723d313537324236",
      },
      {
        name: "Typescript",
        url: "https://camo.githubusercontent.com/8187e1ec20f52c347b917a9b456d7364ec0ea30475ac0b141b225bc4b664698e/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f2d547970655363726970742d3030374143433f7374796c653d666f722d7468652d6261646765266c6f676f3d74797065736372697074266c6f676f436f6c6f723d776869746526636f6c6f723d303037414343",
      },
      {
        name: "Angular",
        url: "https://camo.githubusercontent.com/c0ff1cd041a4c6b5600b1f173610ec2d557337ef3446247c41b6b3db2cb47b63/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f2d416e67756c61722d626c61636b3f7374796c653d666f722d7468652d6261646765266c6f676f3d616e67756c6172266c6f676f436f6c6f723d44443142313626636f6c6f723d464646464646",
      },
      // {
      //   name: "Sass",
      //   url: "https://camo.githubusercontent.com/aa2d67d682b7d59cb0955695b192fc1390c9da34e90aa0c63079c411d01a9c66/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f534153532d686f7470696e6b2e7376673f7374796c653d666f722d7468652d6261646765266c6f676f3d53415353266c6f676f436f6c6f723d7768697465",
      // },
      {
        name: "React js",
        url: "https://camo.githubusercontent.com/6859c6fca6aacfe841d3a2d91b49702a8785becb2da87533dffc5f4d09e2fbbc/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f2d52656163742d626c61636b3f7374796c653d666f722d7468652d6261646765266c6f676f3d7265616374266c6f676f436f6c6f723d36314442464226636f6c6f723d464646464646",
      },
      // "Ngrx-Ngxs",
      {
        name: "Ngrx/Ngxs/Redux",
        url: "https://camo.githubusercontent.com/50aa981f187dd16a89fb299b3bbf9075da3d69d0457fa5dcbfcaa85ec37181b8/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4e6772782d3539334438383f7374796c653d666f722d7468652d6261646765266c6f676f3d6e677278266c6f676f436f6c6f723d7768697465",
      },
      {
        name: "Node js",
        url: "https://camo.githubusercontent.com/eaeba217e2db4ce5504c75c70458a3336deacc9bfe04982334f57965e5f67ad9/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f2d4e6f64656a732d626c61636b3f7374796c653d666f722d7468652d6261646765266c6f676f3d4e6f64652e6a73266c6f676f436f6c6f723d46464646464626636f6c6f723d334338373341",
      },
      {
        name: "Mongodb",
        url: "https://camo.githubusercontent.com/72e92f69f36703548704a9eeda2a9889c2756b5e08f01a9aec6e658c148d014e/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4d6f6e676f44422d3445413934423f7374796c653d666f722d7468652d6261646765266c6f676f3d6d6f6e676f6462266c6f676f436f6c6f723d7768697465",
      },
      {
        name: "Express js",
        url: "https://camo.githubusercontent.com/72e92f69f36703548704a9eeda2a9889c2756b5e08f01a9aec6e658c148d014e/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4d6f6e676f44422d3445413934423f7374796c653d666f722d7468652d6261646765266c6f676f3d6d6f6e676f6462266c6f676f436f6c6f723d7768697465",
      },
      {
        name: "Tailwind css",
        url: "https://camo.githubusercontent.com/e9b080a6541e5355827ea91b6a0302cbbc54af4705b0c6b0f1561a0957ced2fb/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f5461696c77696e645f4353532d3338423241433f7374796c653d666f722d7468652d6261646765266c6f676f3d7461696c77696e642d637373266c6f676f436f6c6f723d7768697465",
      },
      {
        name: "Material UI",
        url: "https://camo.githubusercontent.com/d951e189221e39e49428a00be5c673b3e0e59ce0c6c6293bdedd424f593b5e63/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f6d6174657269616c75692d2532333030383143422e7376673f7374796c653d666f722d7468652d6261646765266c6f676f3d6d6174657269616c2d7569266c6f676f436f6c6f723d7768697465",
      },
      // "CI/CD",
      {
        name: "GIT and GitHub",
        url: "https://camo.githubusercontent.com/fbc3df79ffe1a99e482b154b29262ecbb10d6ee4ed22faa82683aa653d72c4e1/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4769744875622d3130303030303f7374796c653d666f722d7468652d6261646765266c6f676f3d676974687562266c6f676f436f6c6f723d7768697465",
      },
    ],
    CompetetiveSkills: ["C/C++", "Data Structures", "Algorithms", "Scrum"],
    Extras: ["VScode", "Figma", "Webflow"],
  };

  return (
    <>
      <div className="skills-wrap">
        <div className="skills-colomn-wrap">
          <h3>As Web-Developer</h3>
          <ul>
            {Skills.WebSkills.map((skill, index) => {
              return (
                <li key={index}>
                  {/* <img src={skill.url} width="40%" height="40px" alt="skills" /> */}
                  📌 {skill.name}
                </li>
              );
            })}
          </ul>
        </div>
        <div className="skills-colomn-wrap">
          <h3>Others</h3>
          <ul>
            {Skills.CompetetiveSkills.map((skill, index) => {
              return <li key={index}>📌 {skill}</li>;
            })}
          </ul>
        </div>
        <div className="skills-colomn-wrap">
          <h3>Tools</h3>
          <ul>
            {Skills.Extras.map((skill, index) => {
              return <li key={index}>📌 {skill}</li>;
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default SkillsBox;
